import { Checkbox } from './types'

export interface NormalizedCheckbox extends Checkbox {
  fieldName: string
}

const sanitizeFieldName = (value: string) =>
  value.replace(/[^A-Za-z0-9_-]/g, '_')

export const normalizeCheckboxesForForm = (
  checkboxes: Checkbox[] = [],
): NormalizedCheckbox[] =>
  checkboxes.map((checkbox, index) => {
    const checkboxId = checkbox.id || `checkbox-${index}`

    return {
      ...checkbox,
      id: checkboxId,
      fieldName: `checkbox_${index}_${sanitizeFieldName(checkboxId)}`,
    }
  })
